import { styled } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import { ContainerProps } from '@mui/system';
import Container from '@mui/material/Container';
import Drawer from '@mui/material/Drawer';
import Chip from '@mui/material/Chip';

export const LoginPage = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '100vw',
  height: '100%',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.main,
}));

export const SpaceBetweenHolder = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',

  '& > div': {
    maxWidth: '400px',
  },

  '& img': {
    maxWidth: '100%',
  },
}));

export const MainWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
}));

export const Main = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFilledBackground' && prop !== 'isMobile',
})<BoxProps & { isFilledBackground?: boolean; isMobile?: boolean }>(
  ({ theme, isFilledBackground, isMobile }) => ({
    ...(isFilledBackground && { backgroundColor: theme.palette.primary.main }),
    flexGrow: 1,
    padding: 0,
    ...(!isMobile && { paddingLeft: 40 }),
  })
);

export const MainInner = styled(Container, {
  shouldForwardProp: (prop) => !['isFilledBackground', 'isForm'].includes(prop.toString()),
})<ContainerProps & { isFilledBackground?: boolean; isForm?: boolean }>(
  ({ isFilledBackground, isForm }) => ({
    ...(isFilledBackground
      ? { paddingBottom: 70, paddingTop: 70 }
      : isForm
        ? { paddingTop: 120, paddingBottom: 70 }
        : { paddingTop: 70, paddingBottom: 70 }),
    paddingRight: 8,
    paddingLeft: 8,
  })
);

export const MainInnerDesktopContent = styled(Box)(() => ({
  borderRadius: 16,
  backgroundColor: '#fff',
  padding: 24,
}));

export const AsmubipDrawer = styled(Drawer)(() => ({
  width: 250,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '& .MuiListItemText-root': {
    overflow: 'hidden',
    transition: 'all 0.5s',
  },
  '& .MuiListItemIcon-root': {
    transition: 'all 0.5s',
  },
  '& .MuiButtonBase-root': {
    padding: '4px 8px',
  },
  //variants: [],
  variants: [
    {
      props: ({ open }) => open,
      style: {
        '& .MuiListItemIcon-root': {
          marginRight: 32,
        },
        '& .MuiListItemText-root': {
          maxWidth: 250,
        },
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        '& .MuiListItemIcon-root': {
          marginRight: 0,
        },
        '& .MuiListItemText-root': {
          maxWidth: 0,
        },
      },
    },
  ],

  '& div.MuiDrawer-paper': {
    justifyContent: 'space-between',
  },
}));

export const FilterChip = styled(Chip)(() => ({
  flexShrink: 0,
  borderRadius: 8,
}));

export const ContatoPage = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 32,
  flexDirection: 'column',
  gap: '24px',
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '& hr': {
    borderColor: theme.palette.primary.contrastText,
    width: '80px',
    marginLeft: '16px',
    borderBottomWidth: 'medium',
  },
}));

export const ContatoBox = styled(Box)({
  padding: '16px',
  display: 'flex',
  gap: '10px',

  '& h6': {
    fontSize: 14,
  },
  '& h5': {
    fontSize: 22,
  },
  '& div.MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
});

export const SobrePage = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 32,
  flexDirection: 'column',

  '& img': {
    display: 'block',
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
    backgroundColor: theme.palette.primary.main,
  },
}));

export const SobreSection = styled(Box)(({ theme }) => ({
  padding: 24,
  color: theme.palette.primary.contrastText,

  // '&:nth-of-type(2n + 1)': {
  //   backgroundColor: theme.palette.primary.variants[100],
  //   color: theme.palette.primary.variants[0],
  // },
}));

export const ListHolder = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<BoxProps & { isMobile: boolean }>(({ theme, isMobile }) => ({
  ...(!isMobile && {
    padding: '10px',
    backgroundColor: theme.palette['surface-background'].main,
    borderRadius: '18px',
  }),
}));
